import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Color } from "config/colors";
import { FontFamily } from "config/font";
import { CustomIcon } from "components/icon/customIcon.component";
import { Text } from "components/Typography/text.styled";
import { DescriptionContainer, DropDownRow, Row } from "./gigDetail.styled";
import { FontSize } from "config/font";
import { CompanyGig } from "model/Gig";

type Props = {
  gigData: CompanyGig;
};

export const GigDetailDescription: React.FC<Props> = ({ gigData }) => {
  const { t } = useTranslation();
  const [descriptionOpen, setDescriptionOpen] = useState(true);

  return (
    <>
      <DropDownRow
        onClick={() => {
          setDescriptionOpen(!descriptionOpen);
        }}
      >
        <Text
          fontFamily={FontFamily.MontserratRegular}
          fontSize={FontSize.Large}
        >
          {t("GigsCompany.Description")}
        </Text>
        <CustomIcon
          name={descriptionOpen ? "upward_arrow" : "downward_arrow"}
          size="24px"
          color={Color.BurntSienna}
          style={{ marginTop: 10 }}
        />
      </DropDownRow>
      {descriptionOpen && (
        <DescriptionContainer>
          {gigData.description ? (
            <Text style={{ whiteSpace: "pre-line" }}>
              {gigData.description}
            </Text>
          ) : null}
        </DescriptionContainer>
      )}
    </>
  );
};
